var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-iframe-container",style:({ height: _vm.iframeHeight })},[_c('iframe',{staticClass:"form-iframe",attrs:{"frameborder":"0","scrolling":"no","src":_vm.source,"title":"petition"}})])}
var staticRenderFns = []

export { render, staticRenderFns }